module.exports = require("remote");


//////////////////
// WEBPACK FOOTER
// external "remote"
// module id = 231
// module chunks = 0